import { getLabel } from '../labels/labelling-service';
import logger from '../services/logging/logging-service';

import { forEach } from './array-utils';
import { observeNodeMutation } from './dom-utils';

const ADV_INSERTED_STATE = 'inserted';

/**
 *  on mobile, .s-adv-top--m reserves space to avoid layout trashing and compute a faster SpeedIndex metric
 *  this scripts avoids the fixed space should banner not be delivered
 *  setTimeout() is needed for pages with less contents (example: pagelle)
 */
window.addEventListener('load', () => {
  setTimeout(() => {
    const advSkin = document.querySelector('#advContainer_skin');
    if (advSkin) {
      advSkin.classList.remove('s-adv-top--m');
    }
  }, 2000);
});

/**
 * @param {HTML Node} advNode
 * @returns {Object}
 */
export const getAdvData = (advNode) => ({
  reviveId: advNode.getAttribute('reviveid') || advNode.getAttribute('data-reviveid'),
  zoneId: advNode.getAttribute('zoneid') || advNode.getAttribute('data-revivezoneid'),
});

/**
 *
 * @param {String} reviveId
 * @param {String} zoneId
 * @returns {HTML Node}
 */
export const createInsDataNode = (reviveId, zoneId) => {
  const $insDataNode = document.createElement('ins');
  $insDataNode.setAttribute('data-revive-zoneid', zoneId);
  $insDataNode.setAttribute('data-revive-id', reviveId);
  $insDataNode.setAttribute('style', 'display: none');
  return $insDataNode;
};

export const globalReviveAsync = (reviveId) => {
  /* global reviveAsync */
  /* ATTENTION if (reviveAsync) {} --- method reviveAsync get not defined if placed in if statements without typeof and comparation with 'undefined' should be always === and not !== */
  if (!(typeof reviveAsync === 'undefined')) {
    reviveAsync[reviveId].apply(reviveAsync[reviveId].detect());
  } else {
    logger.info('[ADV - INIT] reviveAsync is undefined');
  }
};

export const shouldInjectAdv = (advDataNode) => advDataNode.dataset.state !== ADV_INSERTED_STATE;

export const setAdvInsertedState = (advDataNode) => {
  advDataNode.dataset.state = ADV_INSERTED_STATE;
};

const injectAdvLabel = (advNode) => {
  const $labelNode = document.createElement('div');
  $labelNode.className = 'c-label--advertisement';
  const $labelText = document.createTextNode(getLabel('global.advertisement'));
  $labelNode.appendChild($labelText);
  // Append label as first child
  advNode.insertBefore($labelNode, advNode.firstChild);
  advNode.dataset.labelled = 'true';
};

const shouldInjectLabel = (advNode) => {
  const height = parseInt(window.getComputedStyle(advNode).height, 10);
  const isLabelled = advNode.dataset.labelled === 'true';
  return !isLabelled && height > 150;
};

const getObserverCallback = (advNode) => (_mutationsList, mutationObserver) => {
  // Add a delay to improve the height calculation realiability
  setTimeout(() => {
    if (shouldInjectLabel(advNode)) {
      mutationObserver.disconnect();
      injectAdvLabel(advNode);
    }
  }, 300);
};

/**
 * Observe the adv containers and add labels right after the adv injection
 */
export const initAdvLabels = () => {
  const advNodes = document.querySelectorAll('.c-adv');

  forEach((advNode) => {
    if (advNode.dataset.observed !== 'true') {
      advNode.dataset.observed = 'true';
      const mutationsConfig = { attributes: false, childList: true, subtree: true };
      observeNodeMutation({ targetNode: advNode, callback: getObserverCallback(advNode), mutationsConfig });
    }
  })(advNodes);

  // After 10 sec check again the possible adv's not labelled (i.es. when you open a page in a new tab the observer does not work)
  setTimeout(() => {
    const advNodesNotLabelled = document.querySelectorAll('.c-adv:not([data-labelled="true"])');
    forEach((advNode) => {
      if (shouldInjectLabel(advNode)) {
        injectAdvLabel(advNode);
      }
    })(advNodesNotLabelled);
  }, 10000);
};
